// import { getLodop } from "@/utils/LodopFuncs.js";

export function electronPrint(html,fileName,fun) {
  let flag = navigator.userAgent.match(/(electron)/i)
  if(flag){
    // let LODOP = getLodop();
    let LODOP = window.LODOP
    LODOP.PRINT_INIT(fileName);
    LODOP.SET_PRINT_STYLEA("FontSize", 18);
    LODOP.SET_PRINT_STYLEA("Bold", 1);
    // LODOP.ADD_PRINT_TEXT(50, 231, 500, 39, "打印页面部分内容");
    LODOP.ADD_PRINT_HTM("5%", "5%", "90%", "90%",html);
    LODOP.PREVIEW();
    // LODOP.PRINT_DESIGN();
  }else{
    fun()
  }
}
export function electronTablePrint(html,fileName) {
  let flag = navigator.userAgent.match(/(electron)/i)
  if(flag){
    html = html.replace(new RegExp('border="0"', "gm"),'border="1"');
    html = html.replace(new RegExp('<td class="col--ellipsis" rowspan="1" colspan="1"', "gm"),'<td style="padding: 5px"');
    html = html.replace(new RegExp('<th class="" colspan="1" rowspan="1"', "gm"),'<th style="padding: 5px"');
    // let LODOP = getLodop();
    let LODOP = window.LODOP
    LODOP.PRINT_INIT(fileName);
    LODOP.SET_PRINT_STYLEA("FontSize", 14);
    LODOP.SET_PRINT_STYLEA("Bold", 1);
    // LODOP.ADD_PRINT_TEXT(50, 231, 500, 39, "打印页面部分内容");
    // LODOP.ADD_PRINT_HTM("5%", "5%", "90%", "90%",html);
    LODOP.ADD_PRINT_TABLE("5%", "5%", "90%", "90%",html);
    LODOP.SET_PRINT_STYLEA(0,"Horient",2);
    LODOP.SET_PRINT_STYLEA(0,"Vorient",2);
    LODOP.PREVIEW();
    // LODOP.PRINT_DESIGN();
  }
}
var CreatedOKLodopObject, CLodopJsState;
CLodopJsState = 'complete'
function getLodop(oOBJECT, oEMBED) {
    var strFontTag= "<br><font color='#FF00FF'>打印控件";
    var strLodopInstall   = strFontTag+"未安装!点击这里<a href='install_lodop32.exe' target='_self'>执行安装</a>";
    var strLodopUpdate    = strFontTag+"需要升级!点击这里<a href='install_lodop32.exe' target='_self'>执行升级</a>";
    var strLodop64Install = strFontTag+"未安装!点击这里<a href='install_lodop64.exe' target='_self'>执行安装</a>";
    var strLodop64Update  = strFontTag+"需要升级!点击这里<a href='install_lodop64.exe' target='_self'>执行升级</a>";
    var strCLodopInstallA = "<br><font color='#FF00FF'>Web打印服务CLodop未安装启动，点击这里<a href='CLodop_Setup_for_Win32NT.exe' target='_self'>下载执行安装</a>";
    var strCLodopInstallB = "<br>（若此前已安装过，可<a href='CLodop.protocol:setup' target='_self'>点这里直接再次启动</a>）";
    var strCLodopUpdate   = "<br><font color='#FF00FF'>Web打印服务CLodop需升级!点击这里<a href='CLodop_Setup_for_Win32NT.exe' target='_self'>执行升级</a>";
    var strLodop7FontTag    = "<br><font color='#FF00FF'>Web打印服务Lodop7";
    var strLodop7HrefX86    = "点击这里<a href='Lodop7_Linux_X86_64.tar.gz' target='_self'>下载安装</a>(下载后解压，点击lodop文件开始执行)";
    var strLodop7HrefARM    = "点击这里<a href='Lodop7_Linux_ARM64.tar.gz'  target='_self'>下载安装</a>(下载后解压，点击lodop文件开始执行)";
    var strLodop7Install_X86 = strLodop7FontTag+"未安装启动，"+strLodop7HrefX86;
    var strLodop7Install_ARM = strLodop7FontTag+"未安装启动，"+strLodop7HrefARM;
    var strLodop7Update_X86  = strLodop7FontTag+"需升级，"+strLodop7HrefX86;
    var strLodop7Update_ARM  = strLodop7FontTag+"需升级，"+strLodop7HrefARM;
    var strInstallOK = "，成功后请刷新本页面或重启浏览器。</font>";
    var LODOP;
    try {
        var isWinIE    = (/MSIE/i.test(navigator.userAgent)) || (/Trident/i.test(navigator.userAgent));
        var isWinIE64  = isWinIE && (/x64/i.test(navigator.userAgent));
        var isLinuxX86 = (/Linux/i.test(navigator.platform)) && (/x86/i.test(navigator.platform));
        var isLinuxARM = (/Linux/i.test(navigator.platform)) && (/aarch/i.test(navigator.platform));
        if (isLinuxX86 || isLinuxARM) {
            try {
                LODOP = getCLodop();
            } catch (err) {}
            if (!LODOP && CLodopJsState !== "complete") {
                if (CLodopJsState == "loading") alert("网页还没下载完毕，请稍等一下再操作."); else alert("未曾加载Lodop主JS文件，请先调用loadCLodop过程.");
                return;
            }
            var strAlertMessage;
            if (!LODOP) {
                if (isLinuxX86) strAlertMessage = strLodop7Install_X86; else
                if (isLinuxARM) strAlertMessage = strLodop7Install_ARM; else
                strAlertMessage = strCLodopInstallA + strCLodopInstallB ;
                document.body.innerHTML = strAlertMessage + strInstallOK + document.body.innerHTML;
                return;
            } else {
                if (isLinuxX86 && LODOP.CVERSION < "7.0.4.2") strAlertMessage = strLodop7Update_X86; else
                if (isLinuxARM && LODOP.CVERSION < "7.0.4.2") strAlertMessage = strLodop7Update_ARM; else
                if (CLODOP.CVERSION < "4.1.5.8")              strAlertMessage = strCLodopUpdate;

                if (strAlertMessage) document.body.innerHTML = strAlertMessage+ strInstallOK + document.body.innerHTML;
            }
        } else { //==如果页面有Lodop插件就直接使用,否则新建:==
            if (oOBJECT || oEMBED) {
                if (isWinIE)
                    LODOP = oOBJECT;
                else
                    LODOP = oEMBED;
            } else if (!CreatedOKLodopObject) {
                LODOP = document.createElement("object");
                LODOP.setAttribute("width", 0);
                LODOP.setAttribute("height", 0);
                LODOP.setAttribute("style", "position:absolute;left:0px;top:-100px;width:0px;height:0px;");
                if (isWinIE)
                    LODOP.setAttribute("classid", "clsid:2105C259-1E0C-4534-8141-A753534CB4CA");
                else
                    LODOP.setAttribute("type", "application/x-print-lodop");
                document.documentElement.appendChild(LODOP);
                CreatedOKLodopObject = LODOP;
            } else
                LODOP = CreatedOKLodopObject;
            //==Lodop插件未安装时提示下载地址:==
            if ((!LODOP) || (!LODOP.VERSION)) {
                document.body.innerHTML = (isWinIE64 ? strLodop64Install : strLodopInstall) + strInstallOK + document.body.innerHTML;
                return LODOP;
            }
            if (LODOP.VERSION < "6.2.2.6") {
                document.body.innerHTML = (isWinIE64 ? strLodop64Update : strLodopUpdate) + strInstallOK + document.body.innerHTML;
            }
        }
        //===如下空白位置适合调用统一功能(如注册语句、语言选择等):=======================


        //===============================================================================
        return LODOP;
    } catch (err) {
        alert("getLodop出错:" + err);
    }
}
